import type * as React from 'react';
import { get } from '@Domain/Api';
import aiCostLimitSubjectsFetched, {
	type AiCostLimitSubjectsFetchedAction,
	type AiCostLimitSubjectsPayload,
} from '@Application/AiCostLimits/Subjects/Actions/aiCostLimitSubjectsFetched';
import aiCostLimitSubjectsFetchFailed, {
	type AiCostLimitSubjectsFetchFailedAction,
} from '@Application/AiCostLimits/Subjects/Actions/aiCostLimitSubjectsFetchFailed';
import type FetchAiCostLimitSubjects from '@Application/AiCostLimits/Subjects/Queries/FetchAiCostLimitSubjects';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = AiCostLimitSubjectsFetchedAction | AiCostLimitSubjectsFetchFailedAction;

export default (query: FetchAiCostLimitSubjects) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<AiCostLimitSubjectsPayload>(
				`${parameters.api.host}/api/accounts/${query.accountId}/ai-cost-limit-subjects`,
			);

			const action = aiCostLimitSubjectsFetched(payload, query.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = aiCostLimitSubjectsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
